export enum ProductStatusEnum {
  OnHold = 1,
  Active = 2,
  AtClient = 3,
  InWarehouse = 4,
  Disabled = 5,
}
